<template>
  <div class="premium-hint-container">
      <separator class="premium-hint-separator" />
      <div class="premium-hint">
        <i class="material-icons">redeem</i>
        <p class="premium-hint__text">{{ $t('PREMIUM_HINT.TEXT') }}</p>
      </div>
  </div>
</template>

<script>
import Separator from '../components/Separator'
export default {
  components: { Separator },
}
</script>

<style scoped lang="scss">
@import "../../../scss/colors";

.premium-hint-container{
  margin: 0 16px;
  overflow: hidden;
}

.premium-hint{
  border: 2px solid $feedback;
  display: flex;
  flex-direction: row;
  padding: 10px;
  margin-bottom: 16px;

  &-separator{
    margin: 8px 0 16px 0;
  }

  &__text{
    font-size: 14px;
    line-height: 19px;
    margin: 0;
    margin-left: 8px;
    letter-spacing: 0.5px;
  }
}
</style>